import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button, Box, Typography } from '@mui/material';
//
import { route } from '/@/app/routes';
import { userFlowState } from '/@/app/states/userFlowState';
import { IFrameVideo } from '/@/app/components/IFrameVideo';


export const IntroView = () => {
    const navigate = useNavigate()
    const markViewed = () => {
        userFlowState.markIntroVideoWatched().then(() => {
            navigate(route('/'));
        });
    }

    return (
        <>
            <Typography variant="h4" component="h3" sx={{ textAlign: "center", mt: 3, mb: 3 }}>
                Посмотрите видео о Nestarenie.Expert
            </Typography>
            <Container maxWidth="md" sx={{ textAlign: "center", p: "0!important" }}>
                <IFrameVideo
                    src="https://vk.ru/video_ext.php?oid=708099998&id=456239018&hd=3&hash=06512cec30681d37"
                    placeholderContentId="intro_video_placeholder"
                    aspectRatio={1280 / 720}
                    autoplay={true}
                    sx={{ mt: 3, mb: 3 }}
                />
            </Container>

            <Container maxWidth="md" sx={{ textAlign: "center" }}>
                <Box sx={{ mb: 1 }}>
                    <Button variant="outlined" color="primary" onClick={markViewed}>
                        Продолжить
                    </Button>
                </Box>
                <Box>
                    <Typography variant="body2" component="p" gutterBottom>
                        Вы также сможете вернуться к видео на главной странице.
                    </Typography>
                </Box>
            </Container>
        </>
    )
}
